<div class="chat-shimmer-card">
    <!-- Line 1 -->
    <div class="chat-header">
        <div class="shimmer shimmer-title w10"></div>
        <div class="shimmer shimmer-btn w12"></div>
    </div>

    <!-- Line 2 -->
    <div class="chat-row">
        <div class="shimmer shimmer-text w8"></div>
        <div class="shimmer shimmer-text w8"></div>
    </div>

    <!-- Line 3 -->
    <div class="chat-row">
        <div class="shimmer shimmer-text w7"></div>
        <div class="shimmer shimmer-text w8"></div>
    </div>
</div>
